// extracted by mini-css-extract-plugin
module.exports = {"_softWhite":"#FBF5F3","_orange":"#E28413","Secret":"Secret_Secret__3GHew","PuzzleContainer":"Secret_PuzzleContainer__1lOnS"};